module.exports = __webpack_public_path__ + "media/components/country-flag/static/al-3c54122e448e58d1a3711bb30f70b0fe.svg";